import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: 'https://websiteoss.ecoflow.com/upload/image/1745205744048/KV%20(1)%20(2).jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745317479339/KV%20(1).jpg',
        label: t('label'),
        labelColor: '#D11504',
        title: t('title'),
        desc: t('desc'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn1'),
        lHref: '#eco-content',
        lBtnIsYouToBe: false,
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
